import { apiSdk } from '@/httpClient';
import { Select, SelectProps } from 'antd';
import React from 'react';

export default function BoxTypeInput(props: SelectProps<any>) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState<Array<{ label: string; value: string }>>([]);
  React.useEffect(() => {
    setIsLoading(true);
    apiSdk.BoxTypeService.getAutocompletion({ limit: 200 })
      .then(res => {
        setData(res.map(d => ({ label: d.name || '', value: d.id || '' })));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.label as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
      options={data}
    ></Select>
  );
}
